import classNames from 'classnames'
import React, { useContext } from 'react'
import { BookerContext } from '../Booker'
import { cn, cnWithPrefix } from 'ui/lib/utils'

type Props = {
   children?: React.ReactNode
   className?: string
   type: 'button' | 'submit'
}

const FieldButton = ({ children, className, type }: Props) => {
   const { useTailwindPrefix, showLabels, version, vertical } = useContext(BookerContext)
   const customCn = useTailwindPrefix ? cnWithPrefix('tw-') : cn
   return (
      <button
         type={type}
         className={customCn(
            'itm-booker-field',
            {
               'w-full text-primary-booker-a11y hover:bg-primary-booker-10 bg-primary-booker px-3 whitespace-nowrap overflow-hidden text-ellipsis leading-[45px] border border-primary-booker-border rounded':
                  !useTailwindPrefix,
               'tw-w-full tw-text-primary-booker-a11y hover:tw-bg-primary-booker-10 tw-bg-primary tw-bg-primary-booker tw-px-3 tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis tw-leading-[45px] tw-border tw-border-primary-booker-border tw-rounded':
                  useTailwindPrefix,
               'md:rounded-none': !vertical && !useTailwindPrefix,
               'md:tw-rounded-none': !vertical && useTailwindPrefix,
               'md:-mt-[4px]': !vertical && version === 'padded' && showLabels && !useTailwindPrefix,
               'md:tw--mt-[4px]': !vertical && version === 'padded' && showLabels && useTailwindPrefix,
            },

            className,
         )}
      >
         {children}
      </button>
   )
}

export default FieldButton
